// extracted by mini-css-extract-plugin
module.exports = {"spinner":"EstimatedMargin_spinner__4ooU5"};